import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { ResourceListView } from './ResourceListView'
import { ResourceDetailView } from './ResourceDetailView'
import { ResourceCategoryListView } from './ResourceCategoryListView'
import { ResourceCategoryDetailView } from './ResourceCategoryDetailView'

export const ResourcesView: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ResourceListView />} />
      <Route path="/categories" element={<ResourceCategoryListView />} />
      <Route path="/categories/new" element={<ResourceCategoryDetailView />} />
      <Route
        path="/categories/show/:id"
        element={<ResourceCategoryDetailView />}
      />
      <Route path="/new" element={<ResourceDetailView />} />
      <Route path="/show/:slug" element={<ResourceDetailView />} />
      <Route path="/edit/:slug" element={<ResourceDetailView />} />
    </Routes>
  )
}
